import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { MemberRecentChangeInfoDataGrid } from 'src/modules/member/components/memberRecentChangeInfoDataGrid';
import FormLoaderWrapper from 'src/shared/components/organisms/formLoaderWrapper';

type MemberRecentChangeInfoModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  memberId: number;
  firstName: string;
  lastName: string;
};

export const MemberRecentChangeInfoModal = (props: MemberRecentChangeInfoModalProps) => {
  const { memberId, modalOpen, onClose, firstName, lastName } = props;
  const { t } = useTranslation();

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <>
      <GenericDialog
        open={modalOpen}
        onClose={onCloseHandler}
        onSave={onCloseHandler}
        showDialogActions={false}
        dialogTitle={t('member:tableHeaders.changeHistory')}
        dialogSubTitle={`${firstName} ${lastName}`}
        padding={0}
        dialogContent={
          <FormLoaderWrapper loading={memberId === undefined}>
            <MemberRecentChangeInfoDataGrid memberId={memberId} />
          </FormLoaderWrapper>
        }
      />
    </>
  );
};
